<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-asm-clients">

        <page-title :title="'Twoi klienci'" :back="true"></page-title>

        <slide-x-left-transition :duration="400" :delay="300">
            <form-filter-ph></form-filter-ph>
        </slide-x-left-transition>

        <slide-y-up-transition :duration="500" :delay="400">
            <ion-searchbar v-if="show && ph_slug"
                           mode="md"
                           placeholder="Wyszukaj klienta"
                           @input="handleSearch($event)">
            </ion-searchbar>
        </slide-y-up-transition>

        <div v-for="(item,index) in places" :key="item.slug">
            <item-ph-client
                :index="index+1"
                :name="item.name"
                :slug="item.slug"
                :tax_id="item.tax_id"
                :ebi="item.ebi_number"
                :street="item.street"
                :city="item.city"
                :province="item.province"
                :full_address="item.full_address"
                :brand="item.brand"
                :active="item.loyalty_program ? item.loyalty_program.active : null"
                :status="item.loyalty_program ? item.loyalty_program.status : null">
            </item-ph-client>
        </div>

        <slide-y-up-transition :duration="400" :delay="200">
            <p v-if="show && ph_slug == null" class="text-center">
                Wybierz przedstawiciela,<br/>
                aby wyświetlić listę jego lokali.</p>
        </slide-y-up-transition>

        <slide-y-up-transition :duration="400" :delay="200">
            <p v-if="show && places.length === 0 && ph_slug != null" class="text-center">Brak wyników.</p>
        </slide-y-up-transition>

    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import PageTitle from '@/components/PageTitle.vue';
    import FormFilterPh from '@/forms/FormFilterPh.vue';
    import ItemPhClient from '@/items/ItemPhClient'

    export default {
        name: 'AsmClients',
        components: { PageTitle, FormFilterPh, ItemPhClient },
        data(){
            return {
                show: false,
                searchbarActive: false,
            }
        },
        computed: {
            ...mapState({
                phs: state => state.clients.phs,
                places: state => state.clients.places,
            }),
            ph_slug: {
                set(selectedPhSlug) {
                    this.$store.commit('clients/ASM_SET_CURRENT_PH', selectedPhSlug)
                },
                get() {
                    return this.$store.state.clients.currentPh || null
                }
            }
        },
        mounted(){
            this.show = true;
            this.$store.dispatch('clients/ASM_CLIENTS_REQUEST', null);
        },
        methods: {
            handleSearch(e){
                // handle input with simple debounce
                if(this.timeout) clearTimeout(this.timeout);
                let payload = {'ph_slug' : this.ph_slug, 'search' : e.target.value};
                this.timeout = setTimeout(() => {
                    this.$store.dispatch('clients/PH_CLIENTS_REQUEST', payload);
                }, 200);
            }
        }
    }
</script>

<style lang="scss" scoped>
    ion-card-content{
        padding: 8px 12px;
    }
</style>